import { Recurso, UseCaseRecursoAsync } from "lib.common/dist/CleanArch";
import { Pago, PagoDetalle } from "../entities/Pago";
import { GetDetallesAbonoParams, GetSomeAbonosPasarelaParams } from "../../utils/params/GetSomeAbonosPasarelaParams";
import { AbonosPasarelaRepository } from "../repositories/AbonosPasarelaRepository";
import { ErrDevGenerico } from "lib.common/dist/errorHandler";

export class GetDetallesAbonoUseCase<
    T_OUT extends Pago,
    T_OUT2 extends PagoDetalle
> extends UseCaseRecursoAsync<
    GetDetallesAbonoParams,
    T_OUT2[]
> {
    private repository: AbonosPasarelaRepository<T_OUT,T_OUT2>;
    constructor (repository: AbonosPasarelaRepository<T_OUT,T_OUT2>) {
        super();
        this.repository = repository;
    }

    async call(input: GetDetallesAbonoParams): Promise<Recurso<T_OUT2[]>> {
        try {
            return this.repository.getDetallesAbono(input);
        } catch(error) {
            const errorCapa = new ErrDevGenerico(error as Error);
            return Recurso.fromError<T_OUT2[]>(errorCapa);
        }
    }
}